export default {
  "common":{
    "welcome": "welcome",
    "register": "register",
    "chinese": "chinese",
    "english": "english",
    "khmer": "khmer",
    "captcha": "captcha",
    "sendCaptcha": "send Captcha",
    "china": "china",
    "cambodia": "cambodia",
    "reSendCaptcha": "Send in {s} seconds",
  },
  "placeholder": {
    "phone": "Please enter your phone number",
    "captcha": "Please enter the verification code",
    "searchText": "Please enter search keywords",
  },
  "required": {
    "phone": "phone number cannot be empty",
    "captcha": "verification code cannot be empty",
  }
}